export const SW_INIT = 'sw_init';
export const SW_UPDATE = 'sw_update';
